/**
 * @module types/settings/mapColors
 * @description 地图色阶配置（存储字段名 `map_colors`）
 */

export interface IMapColorSwatch {
  hexa: string;
  alpha: string;
}

export interface IMapColorsValue {
  colorName: string;
  colors: IMapColorSwatch[];
}

/** 与 MapColorSelector/COLORS_MAP.blue 一致的默认色阶 */
const MAP_BLUE_HEX_LIST = [
  '#F0F7FF',
  '#CFE4FF',
  '#A6C9FF',
  '#7DADFF',
  '#5086F3',
] as const;

/**
 * 地图色阶缺省：蓝色主题（未落库时 UI 与重置目标）
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.map_colors 为同一引用语义
 */
export const MAP_COLORS_DEFAULT: IMapColorsValue = Object.freeze({
  colorName: 'blue',
  colors: Object.freeze(
    MAP_BLUE_HEX_LIST.map(hexa => Object.freeze({ hexa, alpha: '100' })),
  ),
}) as IMapColorsValue;

/** 写入 draft 用的默认可变副本（避免冻结对象进 draft） */
export function cloneMapColorsDefault(): IMapColorsValue {
  return {
    colorName: MAP_COLORS_DEFAULT.colorName,
    colors: MAP_COLORS_DEFAULT.colors.map(({ hexa, alpha }) => ({
      hexa,
      alpha,
    })),
  };
}
